import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'murder-hornet-ui';
import { useLocation } from 'react-router';


const NavBar = ({ sideNavOpen, toggleSideNav }) => {
  const location = useLocation();

  return (
    <nav
      className={`navbar z-1 d-flex justify-content-between align-items-center bg-white border-light border-bottom p-3 ${sideNavOpen ? 'sidenav-active' : ''} ${location.pathname === '/dashboard' ? 'dashboard-page' : ''}`}
    >
      <div className='col d-flex'>
        <div className='col-auto me-2'>
          <Button
            ghost
            size='sm'
            className='sidenav-toggle-btn text-dark'
            ariaLabel={sideNavOpen ? 'Collapse' : 'Expand'}
            onClick={(event) => {
              toggleSideNav();
              if (event.currentTarget === document.activeElement) {
                event.currentTarget.blur();
              }
            }}
          >
            <span className='fas fa-bars' />
          </Button>
        </div>
      </div>

      {/* <div className='col-auto'>
      <DropdownButton ghost size='sm' options={[]}>
        <span className='fas fa-cog' aria-label='settings toggle'/>
      </DropdownButton>
    </div> */}
    </nav>
  );
};


NavBar.propTypes = {
  sideNavOpen: PropTypes.bool,
  toggleSideNav: PropTypes.func,
};


export default NavBar;
